import React, { useCallback, useEffect, useState } from "react";
import ProductCard from "../../common/ProductCard";
import DotControls from "../../common/DotControls";
import { Link, navigate } from "gatsby";
import LeftArrow from "../../common/ArrowsButton/LeftArrow";
import RightArrow from "../../common/ArrowsButton/RightArrow";
import useEmblaCarousel from "embla-carousel-react";

const SliderCards = ({ data, handle }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    dragFree: false,
    containScroll: "trimSnaps",
    speed: 20,
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  function handleNext() {
    emblaApi.scrollNext();
  }

  function handlePrev() {
    emblaApi.scrollPrev();
  }

  function handleGoTo(slide) {
    emblaApi.scrollTo(slide);
  }

  function handleClick(e, link) {
    e.preventDefault();
    navigate(link);
  }

  return (
    <div className="relative overflow-hidden max-w-full w-full" ref={emblaRef}>
      {prevBtnEnabled && <LeftArrow onClick={handlePrev} />}
      {nextBtnEnabled && <RightArrow onClick={handleNext} />}
      <div className="flex flex-row">
        {data?.map((product, index) => (
          <div
            key={index}
            className="relative flex-grow-0 flex-shrink-0 basis-[92%] md:basis-[46.7%] lg:basis-[24%] pr-5"
          >
            <ProductCard
              product={product}
              key={index}
              index={index}
              showOnSale={String(product.tags).includes("On Sale")}
            />
          </div>
        ))}
        <div
          className="relative w-full mr-10 xl:mr-14 pr-5 box-border rounded-xl group flex-grow-0 flex-shrink-0 basis-[92%] md:basis-[46.7%] lg:basis-[24%] bg-[#f5f5f5]"
          onClick={(e) => handleClick(e, `/collections/${handle}`)}
        >
          <div className="relative w-full h-full bg-transparent rounded-xl aspect-[auto 799/1024] flex items-center justify-center">
            <Link
              className="text-white bg-[#1f1f1f] w-f m-auto py-3 px-8 leading-7 tracking-[1px] rounded-full
              transform transition-all duration-200 hover:scale-105 font-bold text-[15px]"
              to={`/collections/${handle}`}
            >
              View all
            </Link>
          </div>
        </div>
      </div>

      <div className="relative flex md:hidden justify-center bottom-0 left-0 z-[5] mt-10">
        <DotControls
          arr={[...data, 4]}
          activeIndex={selectedIndex}
          animationDuration="500ms"
          color="black"
          onClick={(e) => handleGoTo(e.clickedIndex)}
        />
      </div>
    </div>
  );
};

export default SliderCards;
